import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SearchService } from '../../../pages/search/services/search.service';
import { Company } from '../../interfaces/company';
import { CompanyDetails } from '../../models/company-details';

@Component({
  selector: 'app-record-cache',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './record-cache.component.html',
  styleUrl: './record-cache.component.scss',
})
export class RecordCacheComponent {
  @Input() company!: Company;
  @Input() recordDetails!: CompanyDetails;

  @Output() refreshInfoClicked = new EventEmitter<boolean>(true);

  searchService = inject(SearchService);

  refreshInfo(clearCache: boolean): void {
    this.refreshInfoClicked.emit(clearCache);
  }
}
